import TopPostsSection from './TopPostsSection';
import { getBrandOnlyTopPosts } from 'utils/api/instagram.api';

const BrandOnlyTopPostsSection = ({
    year,
    week,
    brands,
    countries,
    name,
    ...rest
}) => {
    const queryParams = {
        brand: brands || null,
        country: countries || null,
    };

    return (
        <TopPostsSection
            year={year}
            week={week}
            name={name}
            queryFn={getBrandOnlyTopPosts}
            queryParams={queryParams}
            {...rest}
        />
    );
};

export default BrandOnlyTopPostsSection;
